"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardRatio = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e11e2z7d0"
})(process.env.NODE_ENV === "production" ? {
  name: "w5c09w",
  styles: "position:relative;padding-bottom:111.111%;width:100%;"
} : {
  name: "w5c09w",
  styles: "position:relative;padding-bottom:111.111%;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jYXJkLXJhdGlvLWNvbnRhaW5lci9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJK0IiLCJmaWxlIjoiLi4vLi4vc3JjL2NhcmQtcmF0aW8tY29udGFpbmVyL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHNldERpc3BsYXlOYW1lIH0gZnJvbSAncmVjb21wb3NlJztcblxuY29uc3QgQ2FyZFJhdGlvID0gc3R5bGVkKCdkaXYnKWBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBwYWRkaW5nLWJvdHRvbTogMTExLjExMSU7IC8qIDUwMC80NTAgcmF0aW8gKi9cbiAgd2lkdGg6IDEwMCU7XG5gO1xuXG5jb25zdCBDYXJkUmF0aW9Jbm5lciA9IHN0eWxlZCgnZGl2JylgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBib3R0b206IDA7XG4gIGxlZnQ6IDA7XG4gIHJpZ2h0OiAwO1xuYDtcblxuY29uc3QgQ2FyZFJhdGlvQ29udGFpbmVyID0gKHsgY2hpbGRyZW4gfSkgPT4gKFxuICA8Q2FyZFJhdGlvPlxuICAgIDxDYXJkUmF0aW9Jbm5lcj57Y2hpbGRyZW59PC9DYXJkUmF0aW9Jbm5lcj5cbiAgPC9DYXJkUmF0aW8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBzZXREaXNwbGF5TmFtZSgnQ2FyZFJhdGlvQ29udGFpbmVyJykoQ2FyZFJhdGlvQ29udGFpbmVyKTtcbiJdfQ== */"
});
var CardRatioInner = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e11e2z7d1"
})(process.env.NODE_ENV === "production" ? {
  name: "t37t6d",
  styles: "position:absolute;top:0;bottom:0;left:0;right:0;"
} : {
  name: "t37t6d",
  styles: "position:absolute;top:0;bottom:0;left:0;right:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jYXJkLXJhdGlvLWNvbnRhaW5lci9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVb0MiLCJmaWxlIjoiLi4vLi4vc3JjL2NhcmQtcmF0aW8tY29udGFpbmVyL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHNldERpc3BsYXlOYW1lIH0gZnJvbSAncmVjb21wb3NlJztcblxuY29uc3QgQ2FyZFJhdGlvID0gc3R5bGVkKCdkaXYnKWBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBwYWRkaW5nLWJvdHRvbTogMTExLjExMSU7IC8qIDUwMC80NTAgcmF0aW8gKi9cbiAgd2lkdGg6IDEwMCU7XG5gO1xuXG5jb25zdCBDYXJkUmF0aW9Jbm5lciA9IHN0eWxlZCgnZGl2JylgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBib3R0b206IDA7XG4gIGxlZnQ6IDA7XG4gIHJpZ2h0OiAwO1xuYDtcblxuY29uc3QgQ2FyZFJhdGlvQ29udGFpbmVyID0gKHsgY2hpbGRyZW4gfSkgPT4gKFxuICA8Q2FyZFJhdGlvPlxuICAgIDxDYXJkUmF0aW9Jbm5lcj57Y2hpbGRyZW59PC9DYXJkUmF0aW9Jbm5lcj5cbiAgPC9DYXJkUmF0aW8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBzZXREaXNwbGF5TmFtZSgnQ2FyZFJhdGlvQ29udGFpbmVyJykoQ2FyZFJhdGlvQ29udGFpbmVyKTtcbiJdfQ== */"
});

var CardRatioContainer = function CardRatioContainer(_ref) {
  var children = _ref.children;
  return (0, _core.jsx)(CardRatio, null, (0, _core.jsx)(CardRatioInner, null, children));
};

var _default = (0, _recompose.setDisplayName)('CardRatioContainer')(CardRatioContainer);

exports.default = _default;